import React, { useEffect, useState } from "react";
import styled from "styled-components";
import UserServices from "../based/services/PartnerServices";
import ProductSection from "./ProductSection";
import PartnerPhotoshopFileModal from "./PartnerPhotoshopFileModal";
import PartnerPhotoshopTotal from "./PartnerPhotoshopTotal";
import PartnerLogo from "./PartnerLogo";

const TabOption = {
    Product: 1,
    Account: 2,
    Order: 3,
    Payment: 4,
    Photoshop: 5,
    Logo: 6,
};

const ListTabOption = [
    {
        id: TabOption.Product,
        name: "Sản phẩm phôi và chi phí",
    },
    {
        id: TabOption.Photoshop,
        name: "File PSD Render",
    },
    {
        id: TabOption.Logo,
        name: "Vị trí logo Brand",
    },
];

function EditPartner(props) {
    const { partnerId } = props.match.params;
    const [partner, setPartner] = useState({});
    const [tabId, setTabId] = useState(TabOption.Photoshop);

    useEffect(() => {
        getPartner(partnerId);
    }, []);

    const getPartner = async (id) => {
        const [err, data] = await UserServices.GetPartnerById(id);
        if (!err && data) {
            setPartner(data);
        } else {
            setPartner({});
        }
    };

    if (!partner) return "";
    return (
        <Wrapper>
            <section className="partner-name">
                <div className="partner-form">
                    <label htmlFor="">Tên Partner</label>
                    <input type="text" value={partner.fullName} readOnly />
                </div>
                <div className="partner-form">
                    <label htmlFor="">Email</label>
                    <input type="text" value={partner.userName} readOnly />
                </div>
            </section>

            <section className="partner-table">
                <ul className="nav nav-tabs tabs-bordered">
                    {ListTabOption.map((item, index) => {
                        const isActive = item.id == tabId;
                        return (
                            <li className={`nav-item`} key={index}>
                                <a
                                    className={`nav-link ${isActive ? "active" : ""}`}
                                    data-toggle="tab"
                                    onClick={(e) => {
                                        e.preventDefault();
                                        setTabId(item.id);
                                    }}
                                >
                                    <span>{item.name}</span>
                                </a>
                            </li>
                        );
                    })}
                </ul>
                {tabId == TabOption.Product && <ProductSection partnerId={partnerId} />}
                {tabId == TabOption.Photoshop && <PartnerPhotoshopTotal partnerId={partnerId} />}
                {tabId == TabOption.Logo && <PartnerLogo partnerId={partnerId} />}
            </section>
        </Wrapper>
    );
}

export default EditPartner;

const Wrapper = styled.div`
    section.partner-name {
        background: #fff;
        margin: 20px;
        padding: 24px;
        display: flex;
        align-items: center;
    }

    .partner-form {
        display: flex;
        flex-direction: column;
        margin: 0 12px;
    }

    section.partner-table {
        background: #fff;
        margin: 20px;
        padding: 24px;
        display: flex;
        flex-wrap: wrap;
    }

    .header-action {
        display: flex;
        align-items: center;
        margin: 12px 0;
    }

    .right-action {
        margin-left: auto;
    }

    section.table-left {
        margin-top: 20px;
    }

    section.table-left {
        width: 70%;
    }

    section.table-right {
        flex: 1;
        margin-top: 20px;
        margin-left: 120px;
    }

    ul.nav.nav-tabs.tabs-bordered {
        width: 100%;
    }

    .row-input-data .form-group {
        display: flex;
        flex-direction: column;
        margin: 12px 0;
    }

    .row-input-data .form-group input[type="text"] {
        border: 1px solid #d9d9d9;
        background: #fff;
        padding: 5px;
    }
`;
